import {useEffect, useState} from 'react';

const CHUNK_RELOAD_KEY = 'oogst:chunk-reload-at';
const CHUNK_RELOAD_COOLDOWN_MS = 60 * 1000;
const reloadPage = () => window.location.reload();

export function isChunkLoadError(error) {
    if (!error) {
        return false;
    }

    return error.name === 'ChunkLoadError'
        || /Loading chunk \d+ failed/i.test(error.message || '');
}

export default function ChunkLoadFallback({error, reload = reloadPage}) {
    const [automaticReloadFailed, setAutomaticReloadFailed] = useState(false);
    const isChunkError = isChunkLoadError(error);
    let shouldReload = false;

    if (isChunkError) {
        try {
            const lastReloadAt = Number(window.sessionStorage.getItem(CHUNK_RELOAD_KEY));
            shouldReload = !lastReloadAt || Date.now() - lastReloadAt > CHUNK_RELOAD_COOLDOWN_MS;
        } catch (_) {
            shouldReload = false;
        }
    }

    const attemptAutomaticReload = shouldReload && !automaticReloadFailed;

    useEffect(() => {
        if (!attemptAutomaticReload) {
            return;
        }

        try {
            const lastReloadAt = Number(window.sessionStorage.getItem(CHUNK_RELOAD_KEY));
            if (lastReloadAt && Date.now() - lastReloadAt <= CHUNK_RELOAD_COOLDOWN_MS) {
                return;
            }

            window.sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
            reload();
        } catch (_) {
            setAutomaticReloadFailed(true);
        }
    }, [attemptAutomaticReload, reload]);

    if (!isChunkError) {
        return <p>Er is een fout opgetreden.</p>;
    }

    if (attemptAutomaticReload) {
        return <p>De nieuwste versie wordt geladen…</p>;
    }

    return (
        <div role="alert">
            <p>Er is een nieuwe versie van Oogst.app beschikbaar.</p>
            <button type="button" onClick={reload}>Pagina vernieuwen</button>
        </div>
    );
}
